import React from "react";
import { connect } from "react-redux";
import swal from "sweetalert";
import DynamicTabwiseTable from "../../../components/dynamicscreens/DynamicTabwiseTable";
import endpoint from "../../../config/endpoints";
import {
  FailTogenerateCredentialMsg,
  beatsAssign,
  changeActive,
  deleteFailedMsg,
  deleteWarningMsg,
  deletemsg,
  generateCredentialMsg,
  noInternetMsg,
  saveFailedMsg,
  sendCredentialMsg,
  serverMsg,
  statusmsg,
} from "../../../config/messageconstant";
import { SalesExecutiveJson } from "../../../DynamicFormsJson/MastersJSON/salesExecutive";
import { getSalesExecutiveByAreaWithExtraInfoOptimized } from "../../../Slice/salesExecutive.slice";
import {
  SalesExecutiveColumns,
  SalesExecutiveColumnsGokul,
} from "../../../tableColumns/table-columns";
import { apiDelete, apiGet, apiPost } from "../../../utils/api_service";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import { downloadF } from "../../PDF/PDFDownload";
import { compose } from "recompose";
import { withRouter } from "../../../components/withRouter";
import { getStateByRegion } from "../../../Slice/state.slice";
import { getZoneByState } from "../../../Slice/zone.slice";
import { getDistrictByZone } from "../../../Slice/district.slice";
import { getTalukaByDistrict } from "../../../Slice/taluka.slice";
import { getAreaByTalukaPostBodyUpdated } from "../../../Slice/area.slice";
import { getRegionNew } from "../../../Slice/region.slice";
import { getSalesExecutiveTypeForFilter } from "../../../Slice/salesExecutive.slice";
class SalesExecutiveTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabValue: 1,
      moduleObjDataObj: {},
      isLog: true,
      dynamicMasterData: {
        regionDetail: this.props.regionList?.region,
        stateDetail: this.props.stateList?.stateByRegion,
        zoneDetail: this.props.zoneList?.zoneByState,
        districtDetail: this.props.districtList?.districtByZone,
        talukaDetail: this.props.talukaList?.talukaByDistrict,
        areaDetail: this.props.areaList?.areaByTaluka,

        SalesExecutiveListInActive:
          this.props.salesExecutiveList?.salesExecutive.filter(
            (row) => row.isActive == 0
          ),
        SalesExecutiveListActive:
          this.props.salesExecutiveList?.salesExecutive.filter(
            (row) => row.isActive == 1
          ),
      },
      tabList: [
        {
          label: "Active",
          allyProps: 0,
          columns: SalesExecutiveColumns,
          showExcelDownload: true,
          changeExcelURL: "sales-executive-data",
          isActionColActive: true,
          value: "SalesExecutiveListActive",
          searchList: SalesExecutiveJson.searchList,
        },
        {
          label: "InActive",
          allyProps: 1,
          columns: SalesExecutiveColumns,
          showExcelDownload: true,
          changeExcelURL: "sales-executive-data",
          isActionColActive: true,
          value: "SalesExecutiveListInActive",
          searchList: SalesExecutiveJson.searchList,
        },
      ],
    };
  }
  componentDidMount() {
    const moduleObjData = localStorage.getItem("moduleObj");

    const moduleObjDataObj =
      moduleObjData != null ? JSON.parse(moduleObjData) : {};

    const isBeatAssignValidationForSalesExecutive = localStorage.getItem(
      "isBeatAssignValidationForSalesExecutive"
    );

    if (
      localStorage.getItem("isShowReportingAtSalesExecutiveColumn") &&
      localStorage.getItem("isShowReportingAtSalesExecutiveColumn") == 0
    ) {
      this.setState((prevState) => ({
        tabList: prevState.tabList.map((tab) => ({
          ...tab,
          columns: SalesExecutiveColumnsGokul,
        })),
      }));
    }

    if (
      localStorage.getItem("showFilterDataWiseExcel") &&
      localStorage.getItem("showFilterDataWiseExcel") == 1
    ) {
      this.setState((prevState) => ({
        tabList: prevState.tabList.map((tab) => ({
          ...tab,
          showExcelDownload: false,
          searchList: localStorage.getItem("userTypeId") && localStorage.getItem("userTypeId") == 3
            ? [] : SalesExecutiveJson.searchList,
        })),
      }));
    }

    this.setState({
      moduleObjDataObj,
      isBeatAssignValidationForSalesExecutive,
    });

    this.getListData();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.regionList !== nextProps.regionList) {
      if (this.props.regionList?.region !== nextProps.regionList?.region) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            regionDetail: nextProps.regionList?.region,
          },
        });
      }
    }
    if (this.props.stateList !== nextProps.stateList) {
      if (
        this.props.stateList?.stateByRegion !==
        nextProps.stateList?.stateByRegion
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            stateDetail: nextProps.stateList?.stateByRegion,
          },
        });
      }
    }
    if (this.props.zoneList !== nextProps.zoneList) {
      if (
        this.props.zoneList?.zoneByState !== nextProps.zoneList?.zoneByState
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            zoneDetail: nextProps.zoneList?.zoneByState,
          },
        });
      }
    }
    if (this.props.districtList !== nextProps.districtList) {
      if (
        this.props.districtList?.districtByZone !==
        nextProps.districtList?.districtByZone
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            districtDetail: nextProps.districtList?.districtByZone,
          },
        });
      }
    }
    if (this.props.talukaList !== nextProps.talukaList) {
      if (
        this.props.talukaList?.talukaByDistrict !==
        nextProps.talukaList?.talukaByDistrict
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            talukaDetail: nextProps.talukaList?.talukaByDistrict,
          },
        });
      }
    }
    if (this.props.areaList !== nextProps.areaList) {
      if (
        this.props.areaList?.areaByTaluka !== nextProps.areaList?.areaByTaluka
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            areaDetail: nextProps.areaList?.areaByTaluka,
          },
        });
      }
    }
    if (this.props.stackHolderByAreaList !== nextProps.stackHolderByAreaList) {
      if (
        this.props.stackHolderByAreaList?.stackholder !==
        nextProps.stackHolderByAreaList?.stackholder
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            stackHolderListActive: nextProps.stackHolderByAreaList?.stackholder
              .filter((row) => row.isActive == 1)
              .map((rowData, index) => {
                return { ...rowData, index: index + 1 };
              }),
            stackHolderListInActive:
              nextProps.stackHolderByAreaList?.stackholder
                .filter((row) => row.isActive == 0)
                .map((rowData, index) => {
                  return { ...rowData, index: index + 1 };
                }),
          },
        });
      }
    }
    if (this.props.stockStakeHolderType !== nextProps.stockStakeHolderType) {
      if (
        this.props.stockStakeHolderType?.stockStakeHolderType !==
        nextProps.stockStakeHolderType?.stockStakeHolderType
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            stockStakeHolderTypeDetail:
              nextProps.stockStakeHolderType?.stockStakeHolderType,
          },
        });
      }
    }
    if (this.props.salesExecutiveList !== nextProps.salesExecutiveList) {
      if (
        this.props.salesExecutiveList?.salesExecutive !==
        nextProps.salesExecutiveList?.salesExecutive
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            SalesExecutiveListActive:
              nextProps.salesExecutiveList?.salesExecutive
                .filter((row) => row.isActive == 1)
                .map((rowData, index) => {
                  return { ...rowData, index: index + 1 };
                }),
            SalesExecutiveListInActive:
              nextProps.salesExecutiveList?.salesExecutive
                .filter((row) => row.isActive == 0)
                .map((rowData, index) => {
                  return { ...rowData, index: index + 1 };
                }),
          },
        });
      }
    }
  }

  getListById = async (data) => {
    const {
      getStateByRegion,
      getZoneByState,
      getDistrictByZone,
      getTalukaByDistrict,
      getAreaByTalukaPostBodyUpdated,
      showLoador,
      showNotification,
    } = this.props;
    if (navigator.onLine) {
      console.log(data);
      if (data.region && data.region != "") {
        showLoador({ loador: true });
        await getStateByRegion({ regionIds: data.region }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }
      if (data.state && data.state != "") {
        showLoador({ loador: true });
        await getZoneByState({ stateIds: data.state }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
      if (data.zoneIds && data.zoneIds != "") {
        showLoador({ loador: true });
        await getDistrictByZone({ zoneIds: data.zoneIds }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }
      if (data.district && data.district != "") {
        showLoador({ loador: true });
        await getTalukaByDistrict({ districtIds: data.district }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }
      if (data.taluka && data.taluka != "") {
        let talukaIdsJson = {
          talukaIds: data.taluka,
        };
        showLoador({ loador: true });
        await getAreaByTalukaPostBodyUpdated({ talukaIds: talukaIdsJson }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  generateStaticExcelMethod = () => {
    const { showLoador, showNotification } = this.props;
    showLoador({ loador: true });
    downloadF({
      url: endpoint.exportData + "/sales-executive-data-new",
      ext: "xls",
      openNewTab: true,
    }).then((response) => {
      showLoador({ loador: false });
      if (!response) {
        showNotification({
          msg: serverMsg,
          severity: "error",
        });
      }
    });
  };

  onClickApplySend = (rowData) => {
    const { moduleObjDataObj, isLog } = this.state;

    swal({
      title: "Are you sure?",
      text: sendCredentialMsg,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        if (navigator.onLine) {
          this.props.showLoador({ loador: true });
          apiGet({
            url: endpoint.salesExecutive + "/" + rowData.id + "/password-reset",
          }).then(({ success }) => {
            if (success) {
              if (isLog) {
                if (rowData !== null) {
                  let updatedJsonToSend = JSON.stringify(rowData);

                  let dataToSaveForMLog = {
                    module: {
                      moduleId: moduleObjDataObj.moduleId,
                    },
                    subModule: {
                      subModuleId: moduleObjDataObj.subModuleId,
                    },
                    operationType: 1,
                    type: 1,
                    operationPerformId: rowData.id,
                    updatedJson: updatedJsonToSend,
                  };

                  showLoador({ loador: true });
                  apiPost({
                    url: endpoint.mlog,
                    postBody: dataToSaveForMLog,
                  }).then(({ success }) => {
                    showLoador({ loador: false });
                    if (success) {
                    } else {
                      showNotification({
                        msg: saveFailedMsg,
                        severity: "error",
                      });
                    }
                  });
                }
              }

              this.props.showLoador({ loador: false });
              this.props.showNotification({
                msg: generateCredentialMsg,
              });
            } else {
              this.props.showNotification({
                msg: FailTogenerateCredentialMsg,
                severity: "error",
              });
              this.props.showLoador({ loador: false });
            }
          });
        } else {
          this.props.showNotification({
            msg: noInternetMsg,
            severity: "error",
          });
        }
      }
    });
  };
  getTabValue = (rowValue) => {
    this.setState({
      tabValue: rowValue == 0 ? 1 : 0,
    });
  };
  getListData = async () => {
    const {
      getRegionNew,
      getSalesExecutiveByAreaWithExtraInfoOptimized,
      showLoador,
      showNotification,
    } = this.props;
    if (navigator.onLine) {
      showLoador({ loador: true });
      await getRegionNew().then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });

      showLoador({ loador: true });
      await getSalesExecutiveByAreaWithExtraInfoOptimized({
        userTypeId: 4,
      }).then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  onSearchData = async (data) => {
    const { getSalesExecutiveTypeForFilter, showLoador, showNotification } =
      this.props;
    if (navigator.onLine) {
      let dataToSave = {
        userTypeIds: [4],
        areaIds: data.areaIds,
      };

      showLoador({ loador: true });
      await getSalesExecutiveTypeForFilter({
        dataJson: dataToSave,
      }).then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  onChangeStatus = (rowData) => {
    const { showLoador, showNotification } = this.props;
    const { moduleObjDataObj, isLog, isBeatAssignValidationForSalesExecutive } =
      this.state;

    if (navigator.onLine) {
      let status = rowData.isActive == 1 ? 0 : 1;

      if (isBeatAssignValidationForSalesExecutive == 1) {
        showLoador({ loador: true });
        apiGet({
          url: endpoint.assignBeat + "/by-sales-team?salesTeamId=" + rowData.id,
        }).then(({ data, success }) => {
          showLoador({ loador: false });
          if (!success || data.error) {
            showNotification({ msg: serverMsg, severity: "error" });
          } else {
            if (data && data.data && data.data.length !== 0) {
              showNotification({ msg: beatsAssign, severity: "error" });
            } else {
              swal({
                text: changeActive,
                icon: "warning",
                buttons: true,
                dangerMode: true,
              }).then((willDelete) => {
                if (willDelete) {
                  showLoador({ loador: true });
                  apiPost({
                    url:
                      endpoint.salesExecutive +
                      "/update-is-active/?id=" +
                      rowData.id +
                      "&status=" +
                      status,
                  }).then(({ data, success }) => {
                    if (success) {
                      if (isLog && rowData !== null) {
                        let updatedJsonToSend = JSON.stringify(rowData);
                        let dataToSaveForMLog = {
                          module: {
                            moduleId: moduleObjDataObj.moduleId,
                          },
                          subModule: {
                            subModuleId: moduleObjDataObj.subModuleId,
                          },
                          operationType: 1,
                          type: 1,
                          operationPerformId: rowData.id,
                          updatedJson: updatedJsonToSend,
                        };

                        showLoador({ loador: true });
                        apiPost({
                          url: endpoint.mlog,
                          postBody: dataToSaveForMLog,
                        }).then(({ success }) => {
                          showLoador({ loador: false });
                          if (!success) {
                            showNotification({
                              msg: saveFailedMsg,
                              severity: "error",
                            });
                          }
                        });
                      } else {
                        showLoador({ loador: false });
                      }

                      showNotification({ msg: statusmsg });
                      this.getListData();
                    } else {
                      showLoador({ loador: false });
                      showNotification({ msg: serverMsg, severity: "error" });
                    }
                  });
                }
              });
            }
          }
        });
      } else {
        swal({
          text: changeActive,
          icon: "warning",
          buttons: true,
          dangerMode: true,
        }).then((willDelete) => {
          if (willDelete) {
            showLoador({ loador: true });
            apiPost({
              url:
                endpoint.salesExecutive +
                "/update-is-active/?id=" +
                rowData.id +
                "&status=" +
                status,
            }).then(({ data, success }) => {
              if (success) {
                if (isLog && rowData !== null) {
                  let updatedJsonToSend = JSON.stringify(rowData);
                  let dataToSaveForMLog = {
                    module: {
                      moduleId: moduleObjDataObj.moduleId,
                    },
                    subModule: {
                      subModuleId: moduleObjDataObj.subModuleId,
                    },
                    operationType: 1,
                    type: 1,
                    operationPerformId: rowData.id,
                    updatedJson: updatedJsonToSend,
                  };

                  showLoador({ loador: true });
                  apiPost({
                    url: endpoint.mlog,
                    postBody: dataToSaveForMLog,
                  }).then(({ success }) => {
                    showLoador({ loador: false });
                    if (!success) {
                      showNotification({
                        msg: saveFailedMsg,
                        severity: "error",
                      });
                    }
                  });
                } else {
                  showLoador({ loador: false });
                }

                showNotification({ msg: statusmsg });
                this.getListData();
              } else {
                showLoador({ loador: false });
                showNotification({ msg: serverMsg, severity: "error" });
              }
            });
          }
        });
      }
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  rowAnalytics = (rowData) => {
    let salesExecutiveData = JSON.stringify(rowData);
    localStorage.setItem("salesExecutiveDetails", salesExecutiveData);
    this.props.navigate("/sales-executive-analytics" + "/" + rowData.id);
  };

  rowDelete = (rowData) => {
    const { showNotification, showLoador } = this.props;
    swal({
      title: "Are you sure?",
      text: deleteWarningMsg,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        if (rowData.id) {
          console.log(rowData);
          showLoador({ loador: true });
          apiDelete({
            url: endpoint.salesExecutive + "/" + rowData.id,
          }).then(({ data, success }) => {
            showLoador({ loador: false });
            if (success) {
              if (data && data.data && data.data.statusCode == 200) {
                showNotification({ msg: deletemsg });
                window.location.reload();
              } else {
                showNotification({ msg: deleteFailedMsg, severity: "error" });
              }
            } else {
              showNotification({
                msg: deleteFailedMsg,
                severity: "error",
              });
            }
          });
        }
      }
    });
  };

  render() {
    const { salesExecutiveList } = this.props;
    const { dynamicMasterData, tabList } = this.state;
    const isShowSendCredentialIcon =
      localStorage.getItem("isShowSendCredentialIcon") !== null ? localStorage.getItem("isShowSendCredentialIcon") : 1;
    return (
      <>
        <DynamicTabwiseTable
          showView={true}
          formPathView={SalesExecutiveJson.formPathView}
          dynamicMasterData={dynamicMasterData}
          searchList={SalesExecutiveJson.searchList}
          formPath={SalesExecutiveJson.formPath}
          screenTitle={SalesExecutiveJson.screenTitle}
          getListById={this.getListById}
          fieldMeta={SalesExecutiveJson.fieldMeta}
          showPdfDownload={SalesExecutiveJson.showPdfDownload}
          showExcelDownload={true}
          isExcelStaticUrl={true}
          filterDataExcel={true}
          pdfFileName={SalesExecutiveJson.pdfFileName}
          excelFileName={SalesExecutiveJson.excelFileName}
          showAddButton={SalesExecutiveJson.showAddButton}
          tableColumnsToFilter={SalesExecutiveJson.tableColumnsToFilter}
          tableColumns={SalesExecutiveColumns}
          tableData={salesExecutiveList?.salesExecutive}
          apiBaseURL={SalesExecutiveJson.apiBaseURL}
          callApi={false}
          isActiveURL={SalesExecutiveJson.isActiveURL}
          showAddButtonInTable={true}
          onClickAdd={this.onClickAdd}
          openFormPath={SalesExecutiveJson.openFormPath}
          searchButtonGrid={SalesExecutiveJson.searchButtonGrid}
          getTableDataById={true}
          onSearchData={this.onSearchData}
          getTableData={this.getListData}
          showApplyCredintial={isShowSendCredentialIcon == 1 ? true : false}
          rowStatusTrue={true}
          rowStatus={this.onChangeStatus}
          rowApply={this.onClickApplySend}
          tabList={tabList}
          generateStaticExcelMethod={this.generateStaticExcelMethod}
          changeExcelURL={
            "excel-report-for-sale-executive?stockStakeHolderTypeIds=4"
          }
          isNote={true}
          isNoteValue={"Add Sales Executive & Details"}
          rowList={dynamicMasterData}
          formPathStatic={false}
          showHeadEdit={true}
          staticEdit={false}
          deleteStaticTrue={true}
          getTabValue={this.getTabValue}
          showHeadDelete={true}
          showPegination={true}
          showAnalyticsButtonInTable={
            localStorage.getItem("showAnalyticsIcon") &&
              localStorage.getItem("showAnalyticsIcon") == 1
              ? true
              : false
          }
          rowAnalytics={this.rowAnalytics}
          rowDelete={this.rowDelete}
        />
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  salesExecutiveList: state.salesExecutive,
  stockStakeHolderType: state.stockStakeHolderType,
  stackHolderByAreaList: state.stockholder,
  areaList: state.area,
  regionList: state.region,
  stateList: state.states,
  zoneList: state.zone,
  districtList: state.district,
  talukaList: state.taluka,
});
const mapDispatchToProps = {
  getSalesExecutiveByAreaWithExtraInfoOptimized,
  getStateByRegion,
  getZoneByState,
  getTalukaByDistrict,
  getDistrictByZone,
  getAreaByTalukaPostBodyUpdated,
  showLoador,
  showNotification,
  getRegionNew,
  getSalesExecutiveTypeForFilter,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(SalesExecutiveTable);
